import salesOrderInboundMessagesServiceGen from "./generated/salesOrderInboundMessagesServiceGen";
import { fetchWithAuth } from "../../utils/httpInterceptor";

class salesOrderInboundMessagesService extends salesOrderInboundMessagesServiceGen {
  static _normalizeProcessingStatus(payload = {}) {
    return String(payload?.processingstatus || payload?.processingStatus || "").trim().toLowerCase();
  }

  static _resolveCurrentUserForExecution() {
    try {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      return (
        userData?.username ||
        userData?.userName ||
        userData?.displayName ||
        localStorage.getItem("displayName") ||
        ""
      );
    } catch (_) {
      return localStorage.getItem("displayName") || "";
    }
  }

  static _formatNowAsBackendTimestamp() {
    // Backend columns are "timestamp without time zone", keep local datetime format.
    return new Date().toISOString().slice(0, 19);
  }

  static _applyExecutionAutoFields(payload = {}) {
    const next = { ...payload };
    const status = salesOrderInboundMessagesService._normalizeProcessingStatus(next);
    if (status === "executed") {
      if (!next.executedby) {
        next.executedby = salesOrderInboundMessagesService._resolveCurrentUserForExecution();
      }
      if (!next.executedat) {
        next.executedat = salesOrderInboundMessagesService._formatNowAsBackendTimestamp();
      }
    }
    return next;
  }

  static async update(id, payload) {
    const normalized = salesOrderInboundMessagesService._applyExecutionAutoFields(payload || {});
    return await salesOrderInboundMessagesServiceGen.update(id, normalized);
  }

  static async downloadSourcePdf(id) {
    return this.downloadSourceFile(id, "source-pdf");
  }

  static async downloadSourceEmail(id) {
    return this.downloadSourceFile(id, "source-email");
  }

  static async downloadSourceJson(id) {
    return this.downloadSourceFile(id, "source-json");
  }

  static async downloadSourceFile(id, kind) {
    const safeId = encodeURIComponent(String(id || ""));
    const endpoint = `/api/legacy/sales-order-inbound-messages/${safeId}/${kind}`;
    const response = await fetchWithAuth(endpoint, { method: "GET" });
    if (!response.ok) {
      const detail = await response.text().catch(() => "");
      throw new Error(detail || `Download failed with status ${response.status}`);
    }
    const blob = await response.blob();
    const contentDisposition = response.headers.get("Content-Disposition") || "";
    const filename = this.extractFileNameFromContentDisposition(contentDisposition) || `${safeId}-${kind}`;
    return { blob, filename };
  }

  static extractFileNameFromContentDisposition(contentDisposition) {
    if (!contentDisposition) {
      return null;
    }
    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      try {
        return decodeURIComponent(utf8Match[1]);
      } catch {
        return utf8Match[1];
      }
    }
    const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return plainMatch?.[1] || null;
  }
}

export default salesOrderInboundMessagesService;
